import * as React from 'react';
import './index.scss';
import classNames from 'classnames';
import SwiperCore, { Autoplay, EffectCoverflow, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import 'swiper/swiper.min.css';
import TitleRun from './TitleRun';
import NewTitle from './NewTitleRun';
import { preLoadImg, preLoadNewImg, reportFuc } from './../../../../utils';
SwiperCore.use([Autoplay]);
SwiperCore.use([Navigation]);
interface Props {
  iOld: boolean;
  sTime?: string;
  status?: number;
  toRule?: any;
  toShare?: any;
  abbg: number;
  newCash: number;
}
const { useEffect, useState, useRef } = React;
/**
 * 头图ABTest
 */
const Head: React.FC<Props> = (props) => {
  /**
   * 比较版本号
   */
  const versionCompare = (version1, version2) => {
    version1 = version1 || '0.0.0';
    version2 = version2 || '0.0.0';
    if (version1 == version2) return 0;

    const verArr1 = version1.split('.');
    const verArr2 = version2.split('.');
    const len = Math.max(verArr1.length, verArr2.length);

    for (let i = 0; i < len; i++) {
      const ver1 = parseInt(verArr1[i]);
      const ver2 = parseInt(verArr2[i]);

      if (ver1 > ver2) {
        return 1;
      } else if (ver1 < ver2) {
        return -1;
      }
    }

    return 0;
  };
  /**
   * 获取ios版本号
   * @returns
   */
  // const iosVer = () => {
  //   const str = navigator.userAgent.toLowerCase();
  //   const ver = str.match(/cpu iphone os (.*?) like mac os/);
  //   return ver ? ver[1].replace(/_/g, '.') : false;
  //   // Number(browser.ios_ver()[1].replace('_','.')) 转成常见的数字版本号
  // };
  // const andVer = () => {
  //   const ua = navigator.userAgent.toLowerCase();
  //   const match = ua.match(/android\s([0-9\.]*)/);
  //   return match ? match[1] : false;
  // };
  const { iOld } = props;
  const { sTime, status, toRule, toShare, newCash } = props;
  const [imgLoad, setImgLoad] = useState(false);
  const [index, setIndex] = useState(1);
  const pre = useRef(null);
  const next = useRef(null);
  const [cananimate, setcananimate] = useState(false);
  const preloadImage = (names, cb, prefix) => {
    var n = 0,
      img,
      imgs = {};
    names.forEach(function (name) {
      img = new Image();
      img.onload = (function (name, img) {
        return function () {
          imgs[name] = img;
          ++n === names.length && cb && cb(imgs);
        };
      })(name, img);
      img.src = (prefix || '') + name;
    });
  };
  // const u = navigator.userAgent;
  // const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  // const isAnd = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  // const [canWebpStatus, setCanWebp] = useState(true); //2022.8.17修改为动画帧方式，webp在ios会有兼容问题

  // let isIosH = true;

  // let isAndH = true;

  // if (isIOS) {
  //   isIosH = versionCompare(iosVer(), '14.2') != -1;
  // }
  // if (isAnd) {
  //   isAndH = versionCompare(andVer(), '7') != -1;
  // }
  // const canWebp = (feature, callback) => {
  //   const kTestImages = {
  //     lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
  //     lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
  //     alpha:
  //       'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
  //     animation:
  //       'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
  //   };
  //   const img = new Image();
  //   img.onload = function () {
  //     const result = img.width > 0 && img.height > 0;
  //     callback(feature, result);
  //   };
  //   img.onerror = function () {
  //     callback(feature, false);
  //   };
  //   img.src = 'data:image/webp;base64,' + kTestImages[feature];
  // };

  useEffect(() => {
    if (iOld) {
      preLoadImg().then(() => {
        setImgLoad(true);
      });
    } else {
      preLoadNewImg().then(() => {
        setImgLoad(true);
      });
    }
    // canWebp('lossless', (fea, res) => {
    //   setCanWebp(res && (isIOS ? isIosH : isAndH));
    //   console.log('判断是否支持webp', res && (isIOS ? isIosH : isAndH)); // IOS-14之前的会显示false
    // });
    preloadImage(
      ['sprites.png'],
      function () {
        setcananimate(true);
      },
      'https://diy-assets.msstatic.com/kjmain/'
    );
  }, [iOld]);
  return (
    <div
      className={classNames('abtest-head', { iOld, no: status === 2 })}
      data-ab={props.abbg}
    >
      {/* <div className="xinchun-logo"></div> */}
      {props.abbg == 5 && (
        <span className="newcash">
          <i className="cash-money"></i>
          {(newCash / 100)
            .toFixed(1)
            .toString()
            .split('')
            .map((moneyItem, id) => (
              <i
                className={`num-${moneyItem == '.' ? 'dot' : moneyItem}`}
                key={id}
              ></i>
            ))}
        </span>
      )}
      {!iOld ? (
        <>
          <NewTitle />
          {/* {status !== 2 && props.abbg == 0 && (
            <div className="swiper-cover">
              <Swiper
                slidesPerView={1}
                initialSlide={3}
                loop={true}
                loopAdditionalSlides={3}
                autoplay={false}
                observer={true}
                modules={[EffectCoverflow, Navigation]}
                effect="coverflow"
                navigation={{
                  nextEl: pre.current,
                  prevEl: next.current,
                }}
                coverflowEffect={{
                  rotate: 0,
                  stretch: -25,
                  depth: 150,
                  modifier: 2,
                  slideShadows: false,
                }}
                onSlideChange={(virtualIndex) => {
                  const indexs = [0, 0, 0, 2, 2, 1, 0][
                    virtualIndex.activeIndex
                  ];
                  // console.log('当前轮播', indexs)
                  setIndex(indexs);
                }}
              >
                <SwiperSlide>
                  <div
                    className={classNames('head-invite', { new: true })}
                  ></div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className={classNames('head-invite', { back: true })}
                  ></div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className={classNames('head-invite', { old: true })}
                  ></div>
                </SwiperSlide>
              </Swiper>
              <div className="swiper-button-next" ref={next}></div>
              <div className="swiper-button-pre" ref={pre}></div>
            </div>
          )} */}
          <div className="btn-back">
            <div
              className={classNames('btn', {
                cant: status !== 1,
                can: imgLoad && status === 1,
                // canwebp: canWebpStatus,
                animate: cananimate,
              })}
              onClick={() => {
                console.log('主按钮上报', index);
                reportFuc(
                  'usr/click/ldx/maininvitation',
                  '用户/点击/老带新/主邀请按钮点击',
                  { user_type: index }
                );
                toShare();
              }}
            ></div>
          </div>
        </>
      ) : (
        <>
          <TitleRun />
          {status !== -1 && <h3 className="time">{sTime}</h3>}
          {status === 1 && <i className="toRule" onClick={toRule} />}
          {status !== -1 && (
            <div
              className={classNames('old-btn', {
                cant: status !== 1,
                can: imgLoad && status === 1,
              })}
              onClick={() => {
                reportFuc(
                  'usr/click/ldx/maininvitation',
                  '用户/点击/老带新/主邀请按钮点击',
                  {}
                );
                toShare();
              }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Head;
